import Constants from '../utils/consts';
import Cookies from 'universal-cookie';

var db = new Cookies().get('db', {path: '/' });
var http = require('follow-redirects').https;
var qs = require('querystring');

export default async function addRataStatus(uname, token, id_corso, id_studente, data, importo, status, files, note, data_pagamento, metodo, inviata_sdi, uuid, n_fattura) {
    return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': Constants.apisFolder + 'addRataStatus.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            let resp = JSON.parse(body.toString());
            resolve(resp);
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
            'token': token,
            'uname': uname,
            'id_corso': id_corso,
            'id_studente': id_studente,
            'data': data,
            'importo': importo,
            'status': status,
            'files': files,
            'note': note,
            'data_pagamento': data_pagamento, 
            'metodo': metodo, 
            'inviata_sdi': inviata_sdi, 
            'uuid': uuid, 
            'fattura': n_fattura,
            'db_name': db
        });

        req.write(postData);

        req.end();

        
    });
}
